import React from 'react';
import BearLossCalculator from '../pageComponents/BearLossCalculator';

const BearLossCalculatorPage = () => {
  return <BearLossCalculator />;
};

export default BearLossCalculatorPage;
